












import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class RenderExclamation extends Vue {
  @Prop({type: String}) renderClass?: string
  @Prop({type: String}) anchorClass?: string
  @Prop({type: String}) anchorStyle?: string
  @Prop({type: String}) label?: string
  @Prop({type: String}) href?: string
  @Prop({type: String}) target?: string
  @Prop({type: [String, Boolean]}) value?: string | boolean
  @Prop({type: String}) tip?: string
}
